// src/components/Admin/UserManager/PointManagePanel.jsx
import React, { useState } from 'react';
import {
    Stack,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Typography,
    Button,
} from '@mui/material';
import api from '../../../api/axios';

export default function PointManagePanel({ user, onDone, onClose }) {
    const [amount, setAmount] = useState('');
    const [mode, setMode] = useState('earn');   // earn | use
    const [desc, setDesc] = useState('');       // 🔹 사유(내용)

    const submit = () => {
        const val = parseInt(amount, 10);
        if (!amount || Number.isNaN(val) || val <= 0) {
            alert('1 이상의 값을 입력하세요');
            return;
        }
        if (!desc.trim()) {                         // 🔹 사유 공백 체크
            alert('지급/회수 사유를 입력하세요');
            return;
        }

        api.post(`/api/management/users/${user.id}/point/`, {
            amount: val,
            type: mode,
            description: desc.trim(),                 // 🔹 사유 전송
        })
            .then(() => {
                onDone?.();    // 목록 새로고침
                onClose?.();   // 완료 후 모달 닫기
                setAmount('');
                setDesc('');                           // 🔹 입력 초기화
            })
            .catch(() => alert('포인트 처리 실패'));
    };

    return (
        <Stack
            spacing={2}
            sx={{
                '@media (max-width:600px)': {
                    transform: 'scale(0.9)',
                    transformOrigin: 'top left',
                    '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                    '& .MuiButton-root': { fontSize: '0.8rem', px: 1.6, py: 0.4 },
                    '& .MuiInputBase-input': { fontSize: '0.85rem' },
                },
            }}
        >
            {/* 지급 / 회수 선택 */}
            <RadioGroup row value={mode} onChange={(_, v) => setMode(v)}>
                <FormControlLabel value="earn" control={<Radio />} label="지급" />
                <FormControlLabel value="use" control={<Radio />} label="회수" />
            </RadioGroup>

            {/* 금액 입력 */}
            <TextField
                label="포인트(Leaf)"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                inputProps={{ min: 1 }}
                fullWidth
                autoFocus
            />

            {/* 🔹 사유 입력 */}
            <TextField
                label="사유 / 설명(이벤트 참여로 '지급')"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                multiline
                rows={3}
                fullWidth
                required
            />

            <Typography variant="body2" color="text.secondary">
                입력한 포인트(Leaf)를 {mode === 'earn' ? '더해' : '빼'}서 적용합니다.
            </Typography>

            {/* 버튼 영역 */}
            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button onClick={onClose}>닫기</Button>
                <Button variant="contained" onClick={submit}>
                    확인
                </Button>
            </Stack>
        </Stack>
    );
}
